import { render, staticRenderFns } from "./invoiceUpload.vue?vue&type=template&id=478c87a5&scoped=true"
import script from "./invoiceUpload.vue?vue&type=script&lang=js"
export * from "./invoiceUpload.vue?vue&type=script&lang=js"
import style0 from "./invoiceUpload.vue?vue&type=style&index=0&id=478c87a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c87a5",
  null
  
)

export default component.exports